import { BrandButtonWhite } from "./form/buttons";
import "./backBtn.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
interface BackButtonProps {
  navigate: any;
  destination: string | number;
  text?: string;
  variant?: "text" | "outlined" | "contained";
}

const BackButton = ({
  navigate,
  destination,
  text = "Back",
  variant = "text",
}: BackButtonProps) => {
  return (
    <div className="backButton">
      <BrandButtonWhite
        variant={variant}
        onClick={() =>
          // a numeric destination navigates through browser history instead of to a fixed route
          typeof destination === "number"
            ? navigate(destination)
            : navigate(destination, { replace: true })
        }
      >
        <FontAwesomeIcon icon={faChevronLeft} /> <span>{text}</span>
      </BrandButtonWhite>
    </div>
  );
};

export default BackButton;
